<template>
  <div class="homeworkStatistics" v-if="!totalHomeworkExerciseLoading">
    <div >
      <div
        v-for="(item,index) in totalHomeworkExercise"
        :key="index"
        style="margin-top:20px"
      >
        <div v-if="item.question.mode == '单选'">
          <div>{{index + 1}}、 [{{item.question.mode}}]
            <span v-html="item.question.title"></span>
          </div>
          <div
            class="homeworkStatistics_option"
            v-for="(items,indexs) in item.question.optionList"
            :key="indexs"
          >
          <span v-if="item.userAnswer == items.options && item.question.answer == items.options">
            <i class="iconfont icon-zhengque1 homeworkStatistics_icon homeworkStatistics_icon_true"></i>
          </span>
            <span v-if="item.userAnswer != items.options && item.question.answer == items.options">
            <i class="iconfont icon-zhengque1 homeworkStatistics_icon homeworkStatistics_icon_true"></i>
          </span>
            <span v-if="item.userAnswer == items.options && item.question.answer != items.options">
            <i class="iconfont icon-cuowu homeworkStatistics_icon homeworkStatistics_icon_false"></i>
          </span>
            <span v-if="item.userAnswer != items.options && item.question.answer != items.options">
            <i class="iconfont icon-quan homeworkStatistics_icon"></i>
          </span>
            <span style="line-height:23px">
            {{items.options}}、
            <span v-html="items.name"></span>
          </span>
          </div>
          <div class="homeworkStatistics_data">答对 <span style="color:#41d497">{{item.correctCount}}人({{(item.correctCount/(item.wrongCount+item.correctCount)*100).toFixed(1)}}%)</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;答错<span style="color:#fc5e5e">{{item.wrongCount}}人({{(item.wrongCount/(item.wrongCount+item.correctCount)*100).toFixed(1)}}%)</span></div>
        </div>

        <div v-if="item.question.mode == '多选'">
          <div>{{index + 1}}、 [{{item.question.mode}}]
            <span v-if="item.question.ptitle!=null" v-html="item.question.ptitle"></span>
            <span v-html="item.question.title"></span>
          </div>
          <div
            class="homeworkStatistics_option"
            v-for="(items,indexs) in item.question.optionList"
            :key="indexs"
          >
          <span v-if="item.question.answer.indexOf(items.options) > -1">
            <i class="iconfont icon-xuanze-fangkuang-tianchong homeworkStatistics_icon_true"></i>
          </span>
            <span v-else>
            <i class="iconfont icon-fangkuang"></i>
          </span>
            <span style="line-height:23px">
            {{items.options}}、
            <span v-html="items.name"></span>
          </span>
          </div>
          <div class="homeworkStatistics_data">答对 <span style="color:#41d497">{{item.correctCount}}人({{(item.correctCount/(item.wrongCount+item.correctCount)*100).toFixed(1)}}%)</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;答错<span style="color:#fc5e5e">{{item.wrongCount}}人({{(item.wrongCount/(item.wrongCount+item.correctCount)*100).toFixed(1)}}%)</span></div>
        </div>

        <div v-if="item.question.mode == '判断'">
          <div>{{index + 1}}、 [{{item.question.mode}}]
            <span v-html="item.question.title"></span>
          </div>
          <div >
            <div class="homeworkStatistics_option">
            <span v-if="item.question.answer == '对'">
              <i class="iconfont icon-zhengque1 homeworkStatistics_icon homeworkStatistics_icon_true"></i>
            </span>
              <span v-else>
              <i class="iconfont icon-quan homeworkStatistics_icon"></i>
            </span>
              <span>对</span>
            </div>
            <div class="homeworkStatistics_option">
            <span v-if="item.question.answer == '错'">
              <i class="iconfont icon-zhengque1 homeworkStatistics_icon homeworkStatistics_icon_true"></i>
            </span>
              <span v-else>
              <i class="iconfont icon-quan"></i>
            </span>
              <span>错</span>
            </div>
          </div>
          <div class="homeworkStatistics_data">答对 <span style="color:#41d497">{{item.correctCount}}人({{(item.correctCount/(item.wrongCount+item.correctCount)*100).toFixed(1)}}%)</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;答错<span style="color:#fc5e5e">{{item.wrongCount}}人({{(item.wrongCount/(item.wrongCount+item.correctCount)*100).toFixed(1)}}%)</span></div>
        </div>

        <div v-if="item.question.mode == '填写'">
          <div>{{index + 1}}、 [{{item.question.mode}}]
            <span v-html="item.question.title"></span>
          </div>
          <div class="homeworkStatistics_option">
            <span>答案：</span>
            <span v-html="item.question.answer"></span>
          </div>
          <div class="homeworkStatistics_data">答对 <span style="color:#41d497">{{item.correctCount}}人({{(item.correctCount/(item.wrongCount+item.correctCount)*100).toFixed(1)}}%)</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;答错<span style="color:#fc5e5e">{{item.wrongCount}}人({{(item.wrongCount/(item.wrongCount+item.correctCount)*100).toFixed(1)}}%)</span></div>
        </div>
      </div>
      <div v-if="totalHomeworkExercise.length == 0">
        <div class="homeworkStatistics_none">暂无提交记录</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalHomeworkExerciseLoading: true,
      totalHomeworkExercise: []
    };
  },
  props: {
    homeworkId: null
  },
  computed: {},
  created() {},
  methods: {
    getTotalHomeworkExerciseById(){
      this.totalHomeworkExerciseLoading = true;
      this.api.homework.getTotalHomeworkExerciseById({id:this.homeworkId}).then(result=>{
        if(result.success){
          this.$nextTick(() => {
            this.totalHomeworkExercise = result.data;
            this.totalHomeworkExerciseLoading = false;
          })
        }else{
          this.$message.error(result.message)
          this.totalHomeworkExerciseLoading = false;
        }
      })
    },
  },
  mounted() {
    this.getTotalHomeworkExerciseById();
  },
  watch: {},
};
</script>


<style lang="less" rel="stylesheet/less">
.homeworkStatistics {
  height: calc(100vh - 80px);
  overflow-y: auto;
  padding: 0 20px 20px 20px;
  p {
    display: initial;
  }
  .homeworkStatistics_box {
    border: 1px solid #ccc;
    background-color: #e3e4e6;
    display: flex;
    margin-top: 20px;
  }
  .homeworkStatistics_item {
    flex: 1;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .homeworkStatistics_text_one {
    margin-top: 10px;
    color: #13b041;
  }
  .homeworkStatistics_text_two {
    margin-top: 10px;
    color: #ea1a1a;
  }
  .homeworkStatistics_text_three {
    margin-top: 10px;
  }
  .homeworkStatistics_icon {
    font-size: 18px;
    margin-right: 5px;
  }
  .homeworkStatistics_icon_false {
    color: rgb(252, 94, 94);
  }
  .homeworkStatistics_icon_true {
    color: rgb(65, 212, 151);
  }
  .homeworkStatistics_option {
    margin-left: 20px;
    margin-top: 20px;
  }
  .homeworkStatistics_data{
    padding: 10px;
    background-color: rgba(250, 250, 250, 1);
    text-align: center;
    margin-left: 20px;
    margin-top: 10px;
  }
  .homeworkStatistics_none{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/homeworkStatistics.vue